import { memo } from 'react';
import { useInView } from 'react-intersection-observer';

import { PrivateViewControlsButtons } from '~/components/PrivateBoard/PrivateViewControlsButtons';
import { usePrivateSearchUIHelpers } from '~/components/Search/hooks/usePrivateSearchUIHelpers';
import { SearchPageHeaderTopbar } from '~/components/v2/components/search/SearchPageHeaderTopbar';

export const SearchPageHeader = memo(() => {
  const { showExactSearchHeaders } = usePrivateSearchUIHelpers();
  const {
    entry,
    inView,
    ref: inViewRef,
  } = useInView({
    rootMargin: '120px',
  });

  const isSticky = !!entry && !inView;

  return (
    <>
      <SearchPageHeaderTopbar
        actions={<PrivateViewControlsButtons />}
        // Pass sticky state; topbar decides visibility by search type
        isActionsVisible={isSticky}
      />
      {showExactSearchHeaders && (
        <header
          className="relative flex h-12 shrink-0 items-center justify-between border-b border-b-grey-4 px-4"
          ref={inViewRef}
        >
          <h1 data-testid="SEARCH_PAGE_HEADER_TITLE" className="px-2 py-1 font-semibold text-12 text-grey-11">
            Searching all assets & files
          </h1>

          <div className="shrink-0">{!isSticky && <PrivateViewControlsButtons />}</div>
        </header>
      )}
    </>
  );
});

SearchPageHeader.displayName = 'SearchPageHeader';
